import ApiService from '@/services/api.service';

const PatientPortalMessageService = {
    getAll(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortalMessages/',
            headers: {},
            params: parameters
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientPortalMessages/${id}`);
    },

    add(data) {
        return ApiService.post(`/PatientPortalMessages`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientPortalMessages/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientPortalMessages/${id}`, data);
    }
};

export default PatientPortalMessageService;
